// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/httpDataConfig.js#1 $
'use strict';

/**
* @ngdoc overview
* @name tcApp.module:tcHttpDataConfig
* @description
* # tcHttpDataConfig
* Configure HTTP form data to be sent using name=value syntax instead of JSON.
*/

angular.module('tcApp')
.config(function($httpProvider) {
	// Intercept HTTP request and check for sessionExpired variable
	var interceptor = function($window, $timeout, $rootScope) {
		return {
			'response': function(response) {
				var sessionExpired = response.data.sessionExpired;
				// If server has a new session info, meaning user logged on again with different username/security group, 
				// mark current session as expired
				// Can't use Global Service for this because of cycle dependencies
				if (response.data && response.data.sessionInfo && angular.isDefined($rootScope.sessionInfo)
						&& (!response.data.sessionInfoReset)
						&& ($rootScope.sessionInfo != response.data.sessionInfo)) {
					sessionExpired = true;
				} else if (response.data.sessionInfoReset) {
					// Reset session info if user is changed via username/PIN fields
					$rootScope.sessionInfo = response.data.sessionInfo;
				}
				// If there is a security notification coming from server, display it now
				if (response.data && response.data.counters && response.data.counters.notifications 
					&& angular.isDefined(response.data.counters.notifications.securityMessage)) {
					$window.alert(response.data.counters.notifications.securityMessage);
				}
			
				// Check that IE compatibility header is set if request is going through system.Router
				// If session expired it will go to logon page and this header will not be set
				if ((!response.config.cached) 
					&& (response.config.url.indexOf('system.Router.cls') == 0)
					&& response.headers('X-UA-Compatible') == null) {
					sessionExpired = true;
				}
				var pathNameArray = $window.location.pathname.split('/');
				var appClassName = pathNameArray[pathNameArray.length - 1];
				appClassName = ((angular.isDefined(appClassName) && (appClassName !== '')) ? appClassName : 'system.Home.cls');
				if (sessionExpired) {
					// Set flag to prevent any further async calls that would restart the CSP session
					$rootScope.sessionExpired = true;
					$timeout(function handleLogoutOnSessionExpiry() {
						$window.location.href = $rootScope.getLogoutURL();
					}, 0);
				} else if (response.data.sessionLocked) {
					$window.location.href = (appClassName + '#/Component/websys.LockSession');
				}
				if (response.data.breadcrumbs) {
					$rootScope.$broadcast('updateBreadcrumbs', response.data.breadcrumbs);
				}
				return response;
			}

		};
	};

	$httpProvider.interceptors.push(interceptor);

	$httpProvider.defaults.transformRequest.unshift(function(data) {
		// If this is not an object, defer to native stringification.
		if (!angular.isObject(data)) {
			return ((data == null) ? '' : data.toString());
		}

		// Serialize each key in the object.
		var formData = new FormData(); // eslint-disable-line
		var valueId,dynamicFavouriteData,hasData;
		for (var name in data) {
			if (!Object.prototype.hasOwnProperty.call(data, name)) {
				continue;
			}

			var value;
			if (angular.isUndefined(data[name])) {
				data[name] = '';	
			} 
			
			if (angular.isDefined(data[name].value)) {
				value = data[name].value;	
			} else {
				// Semi-hack - we can remove this when we resolve the issue with angular validation setting value==undefined
				if (angular.isDefined(data[name].tagName)) {
					value = '';
				} else {
					// For non-form values (e.g. TCOMPONENT, TEVENT, etc)
					value = data[name];
				}
			}
			
			// Transform boolean values into the format expected by Cache code
			if (value === true) value = 'on';
			if (value === false) value = '';
			
			// For HRT fields, wrap the value in HTML tags expected by the parser
			// See websys.Component.DrawHTMLRichText() & websys.HTMLRichText.ValidateStream()
			if (data[name].displayType === 'HRT') {
				hasData = (value !== '');
				// if value is blank and was originally blank, do not return empty document
				if ((value === '') && (angular.isDefined(data[name].isDirty)) && (data[name].isDirty)) hasData = 1;
				if (hasData) {
				value = ('<html><head></head><body>' + value + '</body></html>');
			}
			}

			// For listboxes, send each value as a seperate request parameter using the same name
			// (These are handled as %request.Data("x",1) %request.Data("x,2) etc)
			if (angular.isArray(value)) {
				for (var valueIndex = 0; valueIndex < value.length; valueIndex++) {
					// Ignore undefined array values that are inserted by ngMaterial ..
					if (angular.isDefined(value[valueIndex]) && (value[valueIndex] !== null)) {
						formData.append(name, value[valueIndex]);
					}
				}
			} else if (value instanceof Blob) { //eslint-disable-line
				formData.append(name, (value == null) ? '' : value, value.name);
			} else {
				formData.append(name, (value == null) ? '' : value);
				valueId = (angular.isDefined(data[name].valueId) ? data[name].valueId : null);
				if (angular.isDefined(valueId) && (valueId !== null)) {
					formData.append(name + '_ID', valueId);
					// Remove the hidden item itself
					delete data[name + '_ID'];
				}
			}
			// Send the dynamic favourite data as a hidden field in the request
			dynamicFavouriteData = (angular.isDefined(data[name].dynamicFavouriteData) ?
									data[name].dynamicFavouriteData : null);
			if (angular.isDefined(dynamicFavouriteData) && (dynamicFavouriteData !== null)
				&& (dynamicFavouriteData !== '')) {
				var dynamicFavouriteDataArray = dynamicFavouriteData.split('^');
				formData.append('HIDDEN' + dynamicFavouriteDataArray[2] + 'i' + name,
								dynamicFavouriteDataArray[0] + '^' + dynamicFavouriteDataArray[1]);
				delete data['HIDDEN' + dynamicFavouriteDataArray[2] + 'i' + name];
			}
		}
		return (formData);
	});
	
	// Sending formData requires undefined Content-Type
	$httpProvider.defaults.headers.post['Content-Type'] = undefined;
	
	// useApplyAsync to speed up performance
	$httpProvider.useApplyAsync(true);

});
